import { observer } from 'mobx-react';
import {
  SF12QuestionnaireResult,
  sf12QuestionnaireReqDto,
  ErrorCode,
} from '@web/common';
import { Button, Container, Flex } from '@mantine/core';
import classes from '../../../../sharedStyles/Containers.module.css';
import { Questionnaire } from '../../../../component/questionnaire';
import { Header } from '../../../public/navigation';
import { DevContent } from '../../../../util/DevContent';
import { useState } from 'react';
import { devRandomize } from './devRandomize';
import { getSf12QuestionnaireSurveyJSON } from './sf12-survey-specification';
import { showErrorNotification } from '../../../../component/notification';
import { useTranslation } from 'react-i18next';

export const SF12QuestionnaireContent = observer(
  ({
    surveyComplete,
  }: {
    surveyComplete: (surveyResult: SF12QuestionnaireResult) => void;
  }) => {
    const { t } = useTranslation('sf12-questionnaire');
    const [initialData, setInitialData] = useState({});

    return (
      <>
        <Header canLogout />
        <Container fluid className={classes.container} maw="1200px">
          <Questionnaire
            title={t('Title')}
            questionnaire={{
              json: getSf12QuestionnaireSurveyJSON(t),
              schema: sf12QuestionnaireReqDto,
              initial: initialData,
            }}
            onComplete={surveyComplete}
            onError={() =>
              showErrorNotification(ErrorCode.QuestionnaireParsingError)
            }
          />
        </Container>
        <DevContent>
          <Flex direction="row" gap="10px">
            <Button onClick={() => setInitialData(devRandomize(t))}>
              Randomize
            </Button>
          </Flex>
        </DevContent>
      </>
    );
  },
);
